/**
 * One sentence/phrase per line for transcription display (live scribe + translation markers).
 */
export function formatTranscriptLines(text) {
  if (!text || typeof text !== "string") return text || "";
  const trimmed = text.trim();
  if (!trimmed) return trimmed;

  const existingLines = trimmed.split(/\n+/).map((s) => s.trim()).filter(Boolean);
  if (existingLines.length > 1 && existingLines.every((l) => l.length <= 320)) {
    return existingLines.join("\n");
  }

  const flat = trimmed.replace(/\s*\n+\s*/g, " ").replace(/\s+/g, " ").trim();
  const segments = flat
    .split(/(?<=[.!?])\s+/)
    .map((s) => s.trim())
    .filter(Boolean);

  if (segments.length <= 1) return flat;
  return segments.join("\n");
}
